import { render, staticRenderFns } from "./TournamentRules.vue?vue&type=template&id=2dceaec1&scoped=true"
import script from "./TournamentRules.vue?vue&type=script&lang=js"
export * from "./TournamentRules.vue?vue&type=script&lang=js"
import style0 from "./TournamentRules.vue?vue&type=style&index=0&id=2dceaec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dceaec1",
  null
  
)

export default component.exports